import React from "react";
import insuranceCoverage from "../../assets/internalImages/Driver Partner/_mtjd_insurnace_coverage_.webp";
import LoyaltyRewards from "../../assets/internalImages/Driver Partner/_mtjd_loyalty_rewards.webp";
import HealthAssistance from "../../assets/internalImages/Driver Partner/_mtjd_health_assistance.webp";
import FlexibleWork from "../../assets/internalImages/Driver Partner/_mtjd_flexible_work.webp";

const DriverSection4 = () => {
  return (
    <div className="container text-center mt-5 mb-5">
      <h2 className="text-center fw-bold " 
      style={{ color: "#444444", fontSize:"28px" }}>
        More Than Just Deliveries</h2>
      <p className="fs-5 mt-4 text-muted">Real rewards for our driver partners, because we believe your hustle, deserves extra support, and care. </p>

      <div className="container mt-5">
        <div className="row row-cols-1 row-cols-md-2 g-4">
          <div className="col d-flex justify-content-center " style={{height: '80%'}}>
            <div
              className="card new gradient blue w-100 d-flex justify-content-between"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div className="">
                <h4 className="card-title25 text-start fs-4 fw-500 ">
                Insurance Coverage
                </h4>
                <p className="card-text text-secondary text-start mt-2 mx-0 px-0 pt-0 pb-2 fw-100" style={{fontSize: '15px'}}>
               Drive with peace of mind. Get access to low-cost vehicle and personla insurance plans, designed just for delivery partners.
                </p>
              </div>
              <img
                src={insuranceCoverage}
                className="card-img-bottom"
                alt="..."
                style={{height: '30vh'}}
              />
            </div>
          </div>

          <div className="col d-flex justify-content-center" style={{height: '80%'}}>
            <div
              className="card new gradient orange w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div
                className="card-body-forradius text-start align-items-start"
                
              >
                <h5 className="card-title25 text-start fs-4 fw-500">Loyalty Rewards</h5>
                <p className="card-text text-secondary text-start mt-2 mx-0 px-0 pt-0 pb-2 fw-100" style={{fontSize: '15px'}}>
                The more you drive, the more you earn. Unlock exclusive bonuses and milestone perks for staying active with Packky. 
                </p>
              </div>
              <img src={LoyaltyRewards} 
              className="card-img-bottom"
                alt="..."
                style={{height: '30vh'}} />
            </div>
          </div>

          <div className="col d-flex justify-content-center" style={{height: '80%'}}>
            <div
              className="card new gradient green w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div
                className="card-body-forradius d-flex flex-column align-items-start text-start"
                
              >
                <h5 className="card-title25 mr-5 fs-4 fw-500">Health Assistance</h5>
                <p className="card-text text-secondary text-start mt-2 mx-0 px-0 pt-0 pb-2 fw-100" style={{fontSize: '15px'}}>
                Stay strong on and off the road with affordable healthcare for you and your family, plus easy access to medical support. 
                </p>
              </div>
              <img src={HealthAssistance} 
              className="card-img-bottom"
                alt="..."
                style={{height: '30vh'}} />
            </div>
          </div>

          <div className="col d-flex justify-content-center" style={{height: '80%'}}>
            <div
              className="card new gradient purple w-100"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              <div className="card-body-forradius">
                <h5 className="card-title25 text-start fs-4 fw-500 mr-5">
                Flexible Work
                </h5>
                <p className="card-text text-secondary text-start mt-2 mx-0 px-0 pt-0 pb-2 fw-100" style={{fontSize: '15px'}}>
                Be your own boss. Choose when, where, and how much you want to drive -- part-time or full-time, it's up to you.
                </p>
              </div>
              <img src={FlexibleWork}
              className="card-img-bottom"
              alt="..."
              style={{height: '30vh'}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DriverSection4;
